import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from '@tanstack/react-router';
export function AuthLayout() {
    return (_jsx("div", { className: "min-h-screen w-full", style: { background: '#080e1c', color: '#fff' }, children: _jsx(Outlet, {}) }));
}
//# sourceMappingURL=AuthLayout.js.map